import { AxiosResponse } from 'axios';
import { PaginationResponse } from '../models/common/paginationResponse';
import { Result } from '../models/common/resultResponse';
import { ReportTemplateHistoricalRequest } from '../models/request';
import { ReportTemplateHistoricalResponse } from '../models/response';
import { ApiHistoryItem } from '../models/response/apiHistoryItem';
import { api } from './base/api';
import { IReportTemplateHistoricalApi } from './base/reportTemplateHistoricalApi';

const baseRoute: string = 'reportTemplateHistorical';
export class ReportTemplateHistoricalApi extends IReportTemplateHistoricalApi {
  getHistoric(
    request: ReportTemplateHistoricalRequest
  ): Promise<
    AxiosResponse<PaginationResponse<ReportTemplateHistoricalResponse>>
  > {
    return api.get(`${baseRoute}/getHistoric`, { params: request });
  }
  getDetailHistoric(
    guidHistorical: string
  ): Promise<AxiosResponse<Result<ApiHistoryItem[]>>> {
    return api.get(`${baseRoute}/getDetailHistoric`, {
      params: { guidHistorical }
    });
  }
}

